export default __webpack_public_path__ + "static/media/flatware_dark.cc5b8d74.png";